<template>
  <div class="ly_modal_container" :style="{width: '540px', zIndex}">
    <div class="ly_modal_header" @mousedown="dragStart">
      <h1 class="title">받는사람 찾기</h1>
    </div>
    <div class="ly_modal_content" style="min-height:495px">
      <p class="location">{{title}}</p>
      <form action method="post" @submit.prevent>
        <div class="section_search">
          <div class="tray">
            <div class="row">
              <div class="cell">
                <input type="text" class="inp_text" style="width:350px" v-model="searchName" />
                <button type="submit" class="btn_search">서치</button>
              </div>
            </div>
          </div>
        </div>
      </form>

      <ScrollTable scrollHeight="250px" :sourceList="filteredList">
        <template #header>
          <colgroup>
            <col width="80" />
            <col width="150" />
            <col width="270" />
          </colgroup>
          <thead class="table_list_head">
            <tr>
              <CheckAllHeader :selectedList="checkedList" :sourceList="filteredList" />
              <th>이름</th>
              <th>TID</th>
            </tr>
          </thead>
        </template>
        <template #row="{ rowData }">
          <tr :class="{selected: checkedList.includes(rowData)}">
            <td>
              <input type="checkbox" :value="rowData" v-model="checkedList" />
            </td>
            <td>{{rowData.recipientName}}</td>
            <td>{{rowData.nuguTid}}</td>
          </tr>
        </template>
      </ScrollTable>

      <div class="btn_area">
        <button type="button" class="btn_active" @click="onClickSubmit">선택완료</button>
        <button type="button" class="btn_default" @click="close">닫기</button>
      </div>
    </div>

    <button type="button" @click.prevent="close" class="ly_modal_close">
      <span class="ico">팝업 닫기</span>
    </button>
  </div>
</template>

<script>
import popupMixin from "$mixins/popup";
import { mapState } from "vuex";

export default {
  extends: popupMixin,
  props: {
    initGroup: Object,
    onSelected: Function
  },
  data() {
    return {
      tableItems: [],
      searchName: "",
      checkedList: []
    };
  },
  computed: {
    ...mapState(["groupData"]),
    apiUrl() {
      const info = this.initGroup;
      let path = `/happycommunity/recipients/org/${info.orgId}/state/${info.stateId}`;
      if (info.cityId) path = `${path}/city/${info.cityId}`;
      if (info.groupId) path = `${path}/group/${info.groupId}`;
      return path;
    },
    title() {
      const initGroup = this.initGroup;
      const org = _.find(this.groupData, { orgCode: initGroup.orgId });
      const orgName = org ? org.orgName : null;
      if (!orgName) return "전체";
      else if (!initGroup.stateId) return `[${orgName}] 전체`;
      else if (!initGroup.cityId)
        return `[${orgName}] ${initGroup.stateId} 전체`;
      else if (!initGroup.groupId)
        return `[${orgName}] ${initGroup.stateId} ${initGroup.cityId} > 전체`;
      else
        return `[${orgName}] ${initGroup.stateId} ${initGroup.cityId} > ${initGroup.groupId} 그룹`;
    },
    filteredList() {
      if (!this.searchName) return this.tableItems;
      else
        return this.tableItems.filter(item =>
          item.recipientName.match(this.searchName) || 
          item.nuguTid.match(this.searchName)
        );
    }
  },
  methods: {
    onClickSubmit() {
      if (this.onSelected) this.onSelected(this.checkedList);
      this.close();
    }
  },
  mounted() {
    this.$axios
      .get(this.apiUrl)
      .then(({ data }) => (this.tableItems = data.data));
  }
};
</script>
